let $elements = $(".js-img-detect-orientation");

$elements.each(function(){
	
	let $el = $(this);
	
	let img = this;
	
	if(img.complete) {
		setOrientationDataAttr();
	}
	else {
		img.onload = function(){
			setOrientationDataAttr();
		};
	}
	
	function setOrientationDataAttr() {
		
		if(img.naturalHeight > img.naturalWidth) {
			$el.attr('data-orientation', 'vertical');
		}
		else {
			$el.attr('data-orientation', 'horizontal');
		}
		
		$el.addClass('info-item__pic--visible');
		
	}
	
});